import * as cons from "../const";

const INITIAL_STATE = {
    stats: {}
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case cons.SET_STATISTICS:
            return {
                ...state,
                stats: action.payload
            };
        default:
            return state;
    }
};

export default reducer;
